import { PROTOCOL_VERSION, Kind } from "./types";
import { messageId } from "@interlucent/ids";
const now = () => Date.now();
export function hello(p) {
    return { v: PROTOCOL_VERSION, kind: Kind.Hello, ts: now(), payload: p, id: messageId() };
}
export function cmd(type, payload, corr) {
    return { v: PROTOCOL_VERSION, kind: Kind.Cmd, type, payload, corr, ts: now(), id: messageId() };
}
export function ack(payload, corr) {
    return { v: PROTOCOL_VERSION, kind: Kind.Ack, payload, corr, ts: now(), id: messageId() };
}
export function evt(type, payload, seq) {
    return { v: PROTOCOL_VERSION, kind: Kind.Evt, type, payload, ts: now(), seq, id: messageId() };
}
// ============================================================================
// STREAMING SNAPSHOT FACTORIES
// ============================================================================
/**
 * Start a streaming snapshot
 */
export function snapshotStart(payload) {
    return { v: PROTOCOL_VERSION, kind: Kind.SnapshotStart, payload, ts: now(), id: messageId() };
}
/**
 * Send a snapshot chunk
 */
export function snapshotChunk(payload) {
    return { v: PROTOCOL_VERSION, kind: Kind.SnapshotChunk, payload, ts: now(), id: messageId() };
}
/**
 * End a streaming snapshot
 */
export function snapshotEnd(payload, seq) {
    return { v: PROTOCOL_VERSION, kind: Kind.SnapshotEnd, payload, ts: now(), seq, id: messageId() };
}
export function err(code, message, corr) {
    return { v: PROTOCOL_VERSION, kind: Kind.Err, payload: { code, message }, corr, ts: now(), id: messageId() };
}
export function tick(seq) {
    return { v: PROTOCOL_VERSION, kind: Kind.Tick, ts: now(), seq, id: messageId() };
}
export function ping() {
    return { v: PROTOCOL_VERSION, kind: Kind.Ping, ts: now(), id: messageId() };
}
export function pong() {
    return { v: PROTOCOL_VERSION, kind: Kind.Pong, ts: now(), id: messageId() };
}
export function parseMsg(raw) {
    try {
        const m = typeof raw === "string" ? JSON.parse(raw) : raw;
        if (!m || typeof m !== "object")
            return null;
        if (m.v !== PROTOCOL_VERSION)
            return null;
        if (!Object.values(Kind).includes(m.kind))
            return null;
        return m;
    }
    catch {
        return null;
    }
}
